export function InitializeEditor(ele) {
  // exit if already element is initialize.
  if (typeof CKEDITOR.instances[ele] !== 'undefined' && CKEDITOR.instances[ele]) {
    CKEDITOR.instances[ele].destroy(true);
  }

  CKEDITOR.disableAutoInline = true;
  CKEDITOR.timestamp = wbConfig.css_js_version;
  const editor = CKEDITOR.replace(ele, {
    extraAllowedContent: 'a(documentation);abbr[title];code',
    // To enable source code editing in a dialog window, inline editors require the "sourcedialog" plugin.
    startupFocus: false,
    // removePlugins: 'floatingspace,maximize,resize,elementspath,scayt,menubutton,contextmenu,language,liststyle,tabletools,magicline',
    // removePlugins: 'magicline,liststyle,tabletools,scayt,contextmenu,elementspath,forms',
    extraPlugins: 'chkstrike,confighelper,linkclickable,pasteFromGoogleDoc', // uploadimage
    // uploadUrl: '/uploader/upload.php',
    sharedSpaces: {
      top: 'top2',
    },
    fillEmptyBlocks: false,
    shiftEnterMode: CKEDITOR.ENTER_BR,
    enterMode: CKEDITOR.ENTER_BR,
    allowedContent: true,
    height: '325px',
    entities: false,
    basicEntities: false,
    image_previewText: '  ',
    contentsCss: 'body {overflow:auto;white-space:pre-wrap !important;word-wrap: normal !important;line-height: 1.5;font-family:"Lato", "Helvetica Neue", Arial,Helvetica,sans-serif !important;font-weight: 400;font-size: 14px}.cke_editable.placeholder{color:#7a7a7a!important;font-family:"Lato", "Helvetica Neue", Arial,Helvetica,sans-serif !important;font-weight: 400;font-size: 12px !important;font-style: italic !important;}',
  });
}

export function ClearEditorInitialize(ele) {
  if ($(`#${ele}`).length && typeof CKEDITOR.instances[ele] !== 'undefined' && CKEDITOR.instances[ele]) {
    // CKEDITOR.instances[ele].destroy(true);
    setTimeout(() => {
      CKEDITOR.instances[ele].destroy(true);
    }, 500);
  }
}

export function ClearEditorInitImmediate(ele) {
  if (CKEDITOR.instances[ele]) {
    CKEDITOR.instances[ele].destroy();
  }
}


export function InlineCKEditor(ele) {
  if (!$(`#${ele}`).length || document.getElementById(ele) == null || document.getElementById(ele) == 'undefined') {
    return;
  }
  if ($(`#${ele}`).length && typeof CKEDITOR.instances[ele] !== 'undefined') {
    // ClearEditorInitialize(ele);
    setTimeout(() => {
      ClearEditorInitialize(ele);
    }, 500);
  }
  CKEDITOR.disableAutoInline = true;
  CKEDITOR.timestamp = wbConfig.css_js_version;

  CKEDITOR.inline(ele, {
    extraAllowedContent: 'a(documentation);abbr[title];code',
    // To enable source code editing in a dialog window, inline editors require the "sourcedialog" plugin.
    startupFocus: false,
    plugins: '',
    // removePlugins: 'floatingspace,maximize,resize,elementspath,scayt,menubutton,contextmenu,language,liststyle,tabletools,magicline',
    // removePlugins: 'magicline,liststyle,tabletools,scayt,contextmenu,elementspath,forms, toolbar',
    removePlugins: 'toolbar',
    extraPlugins: 'linkclickable,pasteFromGoogleDoc', // uploadimage
    // extraPlugins: 'chkstrike,confighelper,linkclickable',//uploadimage
    // uploadUrl: '/uploader/upload.php',
    sharedSpaces: {
      top: 'top2',
    },
    fillEmptyBlocks: false,
    shiftEnterMode: CKEDITOR.ENTER_BR,
    enterMode: CKEDITOR.ENTER_BR,
    allowedContent: true,
    height: '325px',
    entities: false,
    basicEntities: false,
    // image_previewText : "  ",
    // toolbarStartupExpanded : false,
    contentsCss: 'body {overflow:auto;white-space:pre-wrap !important;word-wrap: normal !important;line-height: 1.5;font-family:"Lato", "Helvetica Neue", Arial,Helvetica,sans-serif !important;font-weight: 400;font-size: 14px}.cke_editable.placeholder{color:#7a7a7a!important;font-family:"Lato", "Helvetica Neue", Arial,Helvetica,sans-serif !important;font-weight: 400;font-size: 12px !important;font-style: italic !important;}',
  });
}

export function InitializeGoalCommentEditor(eleId) {
  console.log('inisalising ediotr');
  if ($(eleId).length && typeof CKEDITOR.instances[eleId] !== 'undefined' && CKEDITOR.instances[eleId]) {
    CKEDITOR.instances[ele].destroy(true);
  }
  CKEDITOR.disableAutoInline = true;
  CKEDITOR.timestamp = css_js_version_control;
  CKEDITOR.replace(eleId, {
    extraAllowedContent: 'a(documentation);abbr[title];code',
    // To enable source code editing in a dialog window, inline editors require the "sourcedialog" plugin.
    startupFocus: false,
    // removePlugins: 'magicline,liststyle,tabletools,scayt,contextmenu,elementspath,forms,font,format',
    extraPlugins: "chkstrike,confighelper,linkclickable,autogrow,mentions,pasteFromGoogleDoc",
    sharedSpaces: {
      top: 'top2',
    },
    fillEmptyBlocks: false,
    autoGrow_onStartup: true,
    autoGrow_minHeight: 120,
    autoGrow_maxHeight: 0,
    shiftEnterMode: CKEDITOR.ENTER_BR,
    enterMode: CKEDITOR.ENTER_BR,
    allowedContent: true,
    height: '120px',
    entities: false,
    basicEntities: false,
    fontSize_sizes: '14px',
    ckeditorMentions: {
			source: []
		},
    contentsCss: 'body {overflow:auto;white-space:pre-wrap !important;word-wrap: normal !important;line-height: 1.5;font-family:"Lato", "Helvetica Neue", Arial,Helvetica,sans-serif !important;font-weight: 400;font-size: 14px}.cke_editable.placeholder{color:#7a7a7a!important;font-family:"Lato", "Helvetica Neue", Arial,Helvetica,sans-serif !important;font-weight: 400;font-size: 12px !important;font-style: italic !important;} body * {font-size: 14px !important;} p{margin:0}',
  });
}
